var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"content kst-list"},[(_vm.theVisible)?[_c('ul',_vm._l((_vm.items),function(message,index){return _c('li',{key:index,staticClass:"has-text-left",domProps:{"innerHTML":_vm._s(message)}})}),0)]:[(!_vm.hideEmpty)?[_vm._v(" "+_vm._s(_vm.theEmptyList)+" ")]:_vm._e()]],2)
}
var staticRenderFns = []

export { render, staticRenderFns }